import type { AxiosInstance, AxiosResponse } from "axios";
import type { RequestArgs } from "./base";

/**
 *
 * @export
 */
export const createRequestFunction = function (axiosArgs: RequestArgs) {
  return <T = unknown, R = AxiosResponse<T>>(axios: AxiosInstance) => {
    const axiosRequestArgs = {
      ...axiosArgs.options,
      url: axiosArgs.url,
      // Only include data if it exists in options
      ...(axiosArgs.options.data
        ? {
            data: {
              ...axiosArgs.options.data,
              hasFile: axiosArgs.hasFile,
            },
          }
        : {}),
      displayError: axiosArgs.displayError,
    };
    return axios.request<T, R>(axiosRequestArgs);
  };
};
